import { useState } from "react";
import { Button } from "@mantine/core";
import { IconDownload } from "@tabler/icons-react";
import { notifications } from "@mantine/notifications";
import { reportsApi, type ReportKey, type ReportParams } from "../../api/reports";
import { errorMessage } from "../../lib/axios";

// Authenticated CSV download (a plain <a download> can't carry the Bearer).
export function CsvDownloadButton({
  reportKey,
  params,
  label = "Export CSV",
}: {
  reportKey: ReportKey;
  params: ReportParams;
  label?: string;
}) {
  const [loading, setLoading] = useState(false);

  async function handle() {
    setLoading(true);
    try {
      await reportsApi.downloadCsv(reportKey, params);
    } catch (err) {
      notifications.show({
        color: "red",
        title: "Download failed",
        message: errorMessage(err),
      });
    } finally {
      setLoading(false);
    }
  }

  return (
    <Button
      variant="default"
      leftSection={<IconDownload size={16} />}
      loading={loading}
      onClick={handle}
    >
      {label}
    </Button>
  );
}
